import flagus from "../assets/images/flags/us.svg";
import flagitaly from "../assets/images/flags/italy.svg";

const languages = {
  it: {
    label: "Italiana",
    flag: flagitaly,
  },
  en: {
    label: "English",
    flag: flagus,
  },
}

export default languages
